import http from './httpService';
import { format } from 'date-fns';
import config from '../config/config.json';

const apiTicketEndpoint = '/api/ticket/';
const apiEventEndpoint = '/api/event/';

const apiAuthEndpoint = '/api/auth/';

const apiToken = process.env.REACT_APP_API_TOKEN;

export async function createTicket(ticket) {
  // const { data } = await http.post(`${apiEndpoint}/create_eating?secret_key=${apiToken}`);
  const data = await http.post(
    `${apiTicketEndpoint}create_eating?secret_key=${apiToken}`,
    ticket
  );
  // console.log(data)
  return data;
}

export async function deleteCoupon(ticketId, mealId, couponDate) {
  // const couponDateFormated = format(couponDate,'ddMMyyyy')

  // const { data } = await http.post(`${apiEndpoint}/create_eating?secret_key=${apiToken}`);
  const data = await http.get(
    `${apiTicketEndpoint}delete_coupon?ticket_id=${ticketId}&mealId=${mealId}&coupon_date=${couponDate}&secret_key=${apiToken}`
  );
  // console.log(data)
  return data;
}

export async function changeCoupon(
  ticketId,
  mealId,
  sessionId,
  couponDate,
  action
) {
  // const couponDateFormated = format(couponDate,'ddMMyyyy')

  // const { data } = await http.post(`${apiEndpoint}/create_eating?secret_key=${apiToken}`);
  const data = await http.get(
    `${apiTicketEndpoint}change_cuponeating/${ticketId}/${mealId}/${sessionId}/${couponDate}/${action}?secret_key=${apiToken}`
  );
  // console.log(data)
  return data;
}

export async function getGif(tag) {
  // const { data } = await http.post(`${apiEndpoint}/create_eating?secret_key=${apiToken}`);
  // var xhr = $.get("http://api.giphy.com/v1/gifs/search?q=ryan+gosling&api_key=YOUR_API_KEY&limit=5");
  const GIPTHY_API_KEY = 'DYHao5HHt6XqWZJQERoqNIXaHhswlGQB';
  const data = await http.get(
    `https://api.giphy.com/v1/gifs/random?tag=${tag}&api_key=${GIPTHY_API_KEY}&limit=1`
  );
  // const  data  = await http.get(`http://api.giphy.com/v1/gifs/search?q=${tag}&api_key=${GIPTHY_API_KEY}&limit=1`);
  // console.log(data)
  return data;
}

export async function getTicket(ticketId) {
  // const { data } = await http.post(`${apiEndpoint}/create_eating?secret_key=${apiToken}`);
  const { data } = await http.get(
    `${apiTicketEndpoint}get_eating/${ticketId}?secret_key=${apiToken}`
  );
  // console.log(data)
  return data;
}

export async function getMoneyReport(startDate, endDate) {
  const startDateFormated = format(startDate, 'ddMMyyyy');
  const endDateFormated = format(endDate, 'ddMMyyyy');
  // const { data } = await http.post(`${apiEndpoint}/create_eating?secret_key=${apiToken}`);
  const url = `${apiTicketEndpoint}money_report/${startDateFormated}/${endDateFormated}?secret_key=${apiToken}`;
  // console.log('url',url);
  const { data } = await http.get(
    `${apiTicketEndpoint}money_report/${startDateFormated}/${endDateFormated}?secret_key=${apiToken}`
  );
  // console.log(data)
  return data;
}

export async function getDaysMoneyReport(startDate, endDate) {
  const startDateFormated = format(startDate, 'ddMMyyyy');
  const endDateFormated = format(endDate, 'ddMMyyyy');
  const { data } = await http.get(
    `${apiTicketEndpoint}days_money_report/${startDateFormated}/${endDateFormated}?secret_key=${apiToken}`
  );
  return data;
}

export async function getMealReport() {
  const { data } = await http.get(
    `${apiTicketEndpoint}meal_report/${config.eventId}?secret_key=${apiToken}`
  );
  // console.log(data)
  return data;
}

export async function getChekinUsers(selectedDate, selectedMeal) {
  const selectedDateFormated = format(selectedDate, 'ddMMyyyy');
  const { data } = await http.get(
    `${apiTicketEndpoint}checkin_users/${selectedDateFormated}/${selectedMeal}?secret_key=${apiToken}`
  );
  return data;
}

// Метод который для купона создает новый купончек
export async function createCheckedCoupon(couponId, userId) {
  const { data } = await http.get(
    `${apiTicketEndpoint}checkedcoupon/create/${couponId}/${userId}?secret_key=${apiToken}`
  );
  return data;

  // return {
  // 	id: 25
  // }
}
export async function deleteCheckedCoupon(checkedCouponId, couponId, userId) {
  const { data } = await http.get(
    `${apiTicketEndpoint}checkedcoupon/delete/${checkedCouponId}/${couponId}/${userId}?secret_key=${apiToken}`
  );
  return data;
}

export async function getTickets(eventId) {
  // const { data } = await http.post(`${apiEndpoint}/create_eating?secret_key=${apiToken}`);
  const { data } = await http.get(
    `${apiEventEndpoint}${eventId}/tickets_eating?secret_key=${apiToken}`
  );
  // console.log(data)
  return data;
}

export async function deleteTicket(ticketId) {
  // const { data } = await http.post(`${apiEndpoint}/create_eating?secret_key=${apiToken}`);
  const data = await http.get(
    `${apiTicketEndpoint}delete_eating/${ticketId}?secret_key=${apiToken}`
  );
  // console.log(data)
  return data;
}

export async function getUserCoupons(userId, checkDate) {
  const checkDateFormated = format(checkDate, 'ddMMyyyy');
  // const { data } = await http.post(`${apiEndpoint}/create_eating?secret_key=${apiToken}`);
  const { data } = await http.get(
    `${apiTicketEndpoint}user_eating/${userId}/${checkDateFormated}?secret_key=${apiToken}`
  );
  // console.log(data)
  return data;
}

export async function getSessions() {
  // const { data } = await http.post(`${apiEndpoint}/create_eating?secret_key=${apiToken}`);
  const eventId = config.eventId;
  const { data } = await http.get(
    `${apiEventEndpoint}${eventId}/meetings?secret_key=${apiToken}`
  );
  // console.log(data)
  return data;
}

export async function getUsers() {
  // const { data } = await http.post(`${apiEndpoint}/create_eating?secret_key=${apiToken}`);
  const eventId = config.eventId;
  const { data } = await http.get(
    `${apiEventEndpoint}customers_paid?secret_key=${apiToken}`
  );
  // const  {data}  = await http.get(`${apiEventEndpoint}${eventId}/customers_paid?secret_key=${apiToken}`);
  // console.log(data)
  return data;
}

export async function getUser(userId,token) {
  // const { data } = await http.post(`${apiEndpoint}/create_eating?secret_key=${apiToken}`);
  const { data } = await http.get(
    `${apiEventEndpoint}customer/${userId}?token=${token}&secret_key=${apiToken}`
  );
  // const  {data}  = await http.get(`${apiEventEndpoint}${eventId}/customers_paid?secret_key=${apiToken}`);
  // console.log(data)
  return data;
}

export async function requestCSRFToken() {
  // const { data } = await http.get('/auth/token/');
  const { data } = await http.get(
    `${apiTicketEndpoint}token?secret_key=${apiToken}`
  );
  http.setCSRF(data.csrf_token);
}

export default {
  createTicket,
  deleteTicket,
  deleteCoupon,
  changeCoupon,
  getTicket,
  getTickets,
  getSessions,
  getUsers,
  getUser,
  getUserCoupons,
  getMoneyReport,
  getDaysMoneyReport,
  getMealReport,
  getChekinUsers,
  createCheckedCoupon,
  deleteCheckedCoupon,
  requestCSRFToken,
  getGif
};
